export default __webpack_public_path__ + "static/media/Savant's Hood of the Forbidden Art.8fd4b59d.jpg";